import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { useTranslate } from 'react-admin'

const useStyles = makeStyles((theme) => ({
  text: {
    fontSize: '13px',
    lineHeight: '15.23px',
    ...theme.mundi.font.roboto400Normal,
  },
}))

export const EventDescriptionField = ({
  source,
  sourceLateFees,
  record,
  ...props
}) => {
  const classes = useStyles()
  const translate = useTranslate()
  return (
    <Typography {...props} className={classes.text}>
      {record[source] === 'invoiceIssued' && (
        <>{translate('resources.invoices.events.invoiceIssuedDescription')}</>
      )}
      {record[source] === 'invoiceAdvanced' && (
        <>{translate('resources.invoices.events.invoiceAdvancedDescription')}</>
      )}
      {record[source] === 'invoiceRequested' && (
        <>
          {translate('resources.invoices.events.invoiceRequestedDescription')}
        </>
      )}
      {record[source] === 'invoiceApproved' && (
        <>{translate('resources.invoices.events.invoiceApprovedDescription')}</>
      )}
      {record[source] === 'collectionReceived' && (
        <>
          {translate('resources.invoices.events.collectionReceivedDescription')}
        </>
      )}
      {record[source] === 'invoiceSettled' && (
        <>{translate('resources.invoices.events.invoiceSettledDescription')}</>
      )}
      {record[source] === 'remainingBalance' && (
        <>
          {translate('resources.invoices.events.remainingBalanceDescription')}
        </>
      )}
      {record[source] === 'invoiceRemainingBalancePaid' && (
        <>
          {translate(
            'resources.invoices.events.invoiceRemainingBalancePaidDescription'
          )}
        </>
      )}
      {record[source] === 'feesCollected' && (
        <>{translate('resources.invoices.events.feesCollectedDescription')}</>
      )}
      {record[source] === 'costAtRepayment' && (
        <>{translate('resources.invoices.events.costAtRepayment')}</>
      )}
      {record[source] === 'adjustedFees' && record[sourceLateFees] > 0 && (
        <>{translate('resources.invoices.events.adjustedFeesBiggerZero')}</>
      )}
      {record[source] === 'adjustedFees' && record[sourceLateFees] < 0 && (
        <>{translate('resources.invoices.events.adjustedFeesLessThanZero')}</>
      )}
    </Typography>
  )
}
